import React, { useEffect, useRef } from 'react';

const TextElement = ({
  element,
  isSelected,
  isEditing,
  draftText,
  isSpacePressed,
  onSelect,
  onStartEdit,
  onChange,
  onCommit,
  onCancel,
  style,
}) => {
  const editableRef = useRef(null);

  useEffect(() => {
    if (isEditing && editableRef.current) {
      editableRef.current.innerText = draftText || '';
      editableRef.current.focus();
      const range = document.createRange();
      range.selectNodeContents(editableRef.current);
      range.collapse(false);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }, [isEditing]);

  if (isEditing) {
    const wrapperStyle = {
      ...style,
      transform: 'none',
      transformOrigin: 'top left',
      overflow: 'visible',
    };
    const editableStyle = {
      ...style,
      position: 'relative',
      left: 'auto',
      top: 'auto',
      width: '100%',
      height: 'auto',
      minHeight: '100%',
      transform: 'none',
      zIndex: 'auto',
    };
    return (
      <div
        data-element-id={element.id}
        style={wrapperStyle}
        className="studio-text-edit-wrapper"
        onPointerDown={(event) => {
          event.stopPropagation();
        }}
      >
        <div
          ref={editableRef}
          className="studio-text-edit"
          style={editableStyle}
          contentEditable
          suppressContentEditableWarning
          spellCheck={false}
          onPointerDown={(event) => {
            event.stopPropagation();
          }}
          onInput={(event) => onChange(event.currentTarget.innerText || '')}
          onBlur={onCommit}
          onKeyDown={(event) => {
            if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
              event.preventDefault();
              onCommit();
            }
            if (event.key === 'Escape') {
              event.preventDefault();
              onCancel();
            }
          }}
        />
      </div>
    );
  }

  return (
    <div
      data-element-id={element.id}
      className={`studio-element ${isSelected ? 'is-selected' : ''} ${element.locked ? 'is-locked' : ''}`}
      style={style}
      onPointerDown={(event) => {
        if (isSpacePressed) {
          return;
        }
        event.stopPropagation();
        onSelect(event);
      }}
      onDoubleClick={(event) => {
        event.stopPropagation();
        onStartEdit();
      }}
    >
      {element.text}
    </div>
  );
};

export default TextElement;
